import { FormResponseType } from '../../../Services/Connection/types/FormResponseType';
import {
  EXTRA_BUTTON_TYPE,
  EXTRA_LINK_TYPE,
  EXTRA_SUBMIT_TYPE,
  EXTRA_SUBTITLE_TYPE,
  EXTRA_TEXT_TYPE,
  EXTRA_TITLE_TYPE,
} from './constants/extraTypes';
import {
  ExtraButtonType,
  ExtraLinkType,
  ExtraTextType,
} from './components/types';

export default class ExtraBuilder {
  private static extraText: (props: ExtraTextType) => HTMLElement;

  private static extraButton: (props: ExtraButtonType) => HTMLElement;

  private static extraLink: (props: ExtraLinkType) => HTMLElement;

  public static getExtra = async (
    extraInfos: FormResponseType['extra']['top'][0]
  ) => {
    const { type } = extraInfos;

    switch (type) {
      case EXTRA_TEXT_TYPE:
      case EXTRA_SUBTITLE_TYPE:
      case EXTRA_TITLE_TYPE: {
        if (!this.extraText) {
          const { default: Text } = await import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ExtraText' */ './components/Text'
          );
          this.extraText = Text;
        }

        return this.extraText(extraInfos);
      }
      case EXTRA_LINK_TYPE: {
        if (!this.extraLink) {
          const { default: Link } = await import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ExtraLink' */ './components/Link'
          );
          this.extraLink = Link;
        }

        return this.extraLink(extraInfos);
      }
      case EXTRA_BUTTON_TYPE:
      case EXTRA_SUBMIT_TYPE: {
        if (!this.extraButton) {
          const { default: Button } = await import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ExtraButton' */ './components/Button'
          );
          this.extraButton = Button;
        }

        return this.extraButton(extraInfos);
      }
      default:
        return null;
    }
  };
}
